import { useParams, Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getProject } from '../api/projects'
import { getElectricalPanelById } from '../api/electricalPanels'
import CableManagement from './CableManagement'

export default function CablesPage() {
  const { projectId, panelId } = useParams<{ projectId: string; panelId?: string }>()

  const { data: project, isLoading: projectLoading } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => getProject(Number(projectId)),
    enabled: !!projectId,
  })

  const { data: panel } = useQuery({
    queryKey: ['electricalPanel', panelId],
    queryFn: () => getElectricalPanelById(Number(panelId!)),
    enabled: !!panelId,
  })

  // Устанавливаем заголовок страницы
  useEffect(() => {
    if (panel) {
      document.title = `Кабели. ${panel.proj_id} - ESS-2`
    } else {
      document.title = 'Система электрических схем ESS-2'
    }
    
    // Восстанавливаем заголовок при размонтировании
    return () => {
      document.title = 'Система электрических схем ESS-2'
    }
  }, [panel])

  if (projectLoading) {
    return <div className="text-center py-8">Загрузка проекта...</div>
  }

  if (!project) {
    return <div className="text-center py-8 text-red-600">Проект не найден</div>
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <Link to={`/projects/${projectId}`} className="text-blue-600 hover:text-blue-800 mb-2 inline-block">
            ← Назад к {project.name}
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">
            Кабели. {panel ? `${panel.proj_id} (${panel.name})` : 'Кабели'}
          </h1>
        </div>
      </div>

      {/* Cable Management Component */}
      <CableManagement 
        projectId={Number(projectId!)} 
        electricalPanelId={panelId ? Number(panelId) : undefined}
      />
    </div>
  )
} 